import ShuttleIcon from '@/assets/icons/airport-shuttle-white.svg?react';
import { ServiceReservationGuide } from '@/components/ServiceReservationGuide';

export function BusAccessRestrictedGuide() {
    return (
        <ServiceReservationGuide
            icon={<ShuttleIcon className="icon-svg" />}
            title="별빛버스 예약 안내"
            description="현재 이 서비스는 이용이 제한되어 있습니다. 이용이 필요하시면 관리자에게 문의해주세요."
            detailLabel="현재 상태"
            detailValue="이용 제한"
            iconBackgroundColor="#00D1AB"
        />
    );
}
